var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMopSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 56,
    viewBox: "0 0 46 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0498 17.5176C26.6798 17.5176 26.3813 17.219 26.3813 16.8534C26.3813 11.6896 22.1542 7.48837 16.9578 7.48837C16.5879 7.48837 16.2894 7.192 16.2894 6.82423C16.2894 6.45646 16.5879 6.16009 16.9578 6.16009C22.8918 6.16009 27.7182 10.9562 27.7182 16.8534C27.7182 17.219 27.4197 17.5176 27.0498 17.5176ZM5.33858 24.9876C0.838846 18.6036 2.40726 9.77285 8.83019 5.30341C15.2553 0.833966 24.1423 2.3894 28.6398 8.77555C33.1395 15.1595 31.5711 23.9881 25.1482 28.4597C18.7231 32.9292 9.83614 31.3716 5.33858 24.9876ZM30.9113 7.19416C25.5354 -0.431584 14.9178 -2.29205 7.24231 3.04705C-0.435357 8.38832 -2.30664 18.9389 3.06708 26.5668C8.12062 33.7382 17.808 35.8107 25.3278 31.5965L27.9173 35.2699L26.5565 36.2196L39.3764 54.4132C40.43 55.9081 42.5024 56.2715 44.0081 55.2244C45.5116 54.1774 45.8772 52.1179 44.8237 50.623L32.0038 32.4294L30.6409 33.3748L28.0514 29.7015C34.6106 24.1201 35.9627 14.3656 30.9113 7.19416Z",
    fill: "#0071FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMopSearch);
export default __webpack_public_path__ + "static/media/mop-search.6c56e3558b36025dd1d9efe727bc1568.svg";
export { ForwardRef as ReactComponent };